export default "__VITE_ASSET__3UVB4xTh__"